// extracted by mini-css-extract-plugin
module.exports = {"root":"widgetLaunches_root__27Pdm","cardRoot":"widgetLaunches_cardRoot__AdCbh","cardContent":"widgetLaunches_cardContent__r5wg6","subtitle":"widgetLaunches_subtitle__Q5gwW"};